import { render, staticRenderFns } from "./ListVehicleBusinessUnit.vue?vue&type=template&id=2675ece0&"
import script from "./ListVehicleBusinessUnit.vue?vue&type=script&lang=js&"
export * from "./ListVehicleBusinessUnit.vue?vue&type=script&lang=js&"
import style0 from "./ListVehicleBusinessUnit.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports